module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-header header-container"
  }, [(!_vm.isModalComp) ? _c('div', {
    staticClass: "header-wrapper dflex justify-space-between align-center width100",
    class: {
      'no-modalComp': !_vm.isModalComp
    }
  }, [_c('div', {
    staticClass: "_inner-wrapper _left"
  }, [(_vm.showGoBack) ? _c('v-icon', {
    staticClass: "go-back mr-3",
    attrs: {
      "color": "black"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("\n        arrow_back_ios\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isAuthenticated) ? _c('img', {
    attrs: {
      "src": _vm.leftAltIcon
    },
    on: {
      "click": _vm.openSearchModal
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "_inner-wrapper _center"
  }, [_c('img', {
    attrs: {
      "src": _vm.centerImg
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: _vm.isAuthenticated ? 'AlbumIndex' : 'Home'
        })
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_inner-wrapper _right"
  }, [(_vm.showRightAltIcon) ? _c('span', {
    on: {
      "click": function($event) {
        _vm.openMusicPlayer()
      }
    }
  }, [(_vm.isPlaying) ? _c('img', {
    staticClass: "right-alt-icon mt-1",
    attrs: {
      "src": require("../../../../static/images/music-wave.gif"),
      "width": "25"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPlaying) ? _c('img', {
    staticClass: "right-alt-icon",
    attrs: {
      "src": _vm.rightAltIcon,
      "width": "30"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.hideUser && _vm.isAuthenticated && !_vm.onProfilePage) ? _c('user-tag', {
    class: {
      'ml-3': _vm.showRightAltIcon
    },
    attrs: {
      "user": _vm.currentUser,
      "hideTick": "",
      "showAvatar": "",
      "hideName": "",
      "width": _vm.avatarWidth,
      "height": _vm.avatarHeight
    }
  }) : _vm._e()], 1)]) : _c('div', {
    staticClass: "header-wrapper dflex justify-space-between align-center width100",
    class: {
      isModalComp: _vm.isModalComp
    }
  }, [_c('div', {
    staticClass: "_inner-wrapper _left"
  }, [(_vm.showModalCompLeftIcon) ? _c('img', {
    attrs: {
      "src": _vm.leftAltIcon
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "_inner-wrapper _center ml-0"
  }, [_c('img', {
    attrs: {
      "src": _vm.appLogo
    },
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: _vm.isAuthenticated ? 'AlbumIndex' : 'Home'
        })
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "_inner-wrapper _right"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../static/images/ic_close_dark.svg"),
      "width": "18"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  })])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "content-class": "search-dialog",
      "background-color": "red",
      "transition": "slide-up"
    },
    model: {
      value: (_vm.searchModalActive),
      callback: function($$v) {
        _vm.searchModalActive = $$v
      },
      expression: "searchModalActive"
    }
  }, [_c('search', {
    ref: "searchRef",
    on: {
      "closeSearchModal": _vm.closeSearchModal
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dc52124","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mobile/components/header.vue
// module id = 1690
// module chunks = 180